import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';

import { CamtlReportsComponent } from './reports.component';
import { S3Service } from '../../../../shared/s3.service';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        CamtlReportsComponent,
    ],
    providers: [S3Service]
})
export class CamtlReportsModule { }
